import { IChartBackendService, ISorter, RawChartDataLike, ChartConfigLike } from "./types";

export class LineChartBackendServiceTS {
  private readonly chartBackendService: IChartBackendService;
  private readonly sorter: ISorter;

  constructor(chartBackendService: IChartBackendService, sorter: ISorter) {
    this.chartBackendService = chartBackendService;
    this.sorter = sorter;
  }

  async fetchJson(tableId: string | number, filter: any, config: any, isBiView?: boolean): Promise<any> {
    return this.chartBackendService.fetchJson(tableId, filter, config, isBiView);
  }

  getRepresentation(resultData: RawChartDataLike, config: ChartConfigLike) {
    let data: any[] = [];

    const multipleSeries = (config as any).chartSeries && (config as any).chartSeries.fieldName;

    const seriesType = multipleSeries ? resultData.config.series.data_type : resultData.config.key.data_type;
    const xAxisType = resultData.config.key.data_type;
    const valueType = resultData.config.values.data_type;

    const seriesParser = this.chartBackendService.getParserForType(seriesType);
    const xAxisParser = this.chartBackendService.getParserForType(xAxisType);
    const valueParser = this.chartBackendService.getParserForType(valueType);

    data = this.chartBackendService
      .nest()
      .key(d => (multipleSeries ? seriesParser(d.series) : ""))
      .key(d => xAxisParser(d.key))
      .rollup((array: any[]) => {
        if (array.length > 1) throw new Error("Error: Found multiple data points for single category combination.");
        return valueParser(array[0].values[0]);
      })
      .excludeNullKeys(true)
      .entries(resultData.values);

    // Sort inner x-axis values by xAxis type
    data.forEach(series => {
      series.values = this.sorter.sort(series.values, {
        dataType: xAxisType,
        valueParser: (item: any) => item.key,
      });
    });

    // Sort outer series by series type
    data = this.sorter.sort(data, {
      dataType: seriesType,
      valueParser: (item: any) => item.key,
    });

    return data;
  }
}

export function createAngularCompatibleLineService(chartBackendService: IChartBackendService, sorter: ISorter) {
  const service = new LineChartBackendServiceTS(chartBackendService, sorter);
  return {
    fetchJson: service.fetchJson.bind(service),
    getRepresentation: service.getRepresentation.bind(service),
  };
}


